// extracted by mini-css-extract-plugin
module.exports = {"bannerForLaunch":"BannerForLaunch_bannerForLaunch__Rdgl8","content":"BannerForLaunch_content__4R_kE"};